// extracted by mini-css-extract-plugin
export default {"header":"Invites-module__header__Jjy8l","button":"Invites-module__button__63t64"};